"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addClasses;
function addClasses(Element, classes) {
    for (var i = 0, l = classes.length; i < l; ++i) {
        Element.classList.add(classes[i]);
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/kompo-util/lib/addClasses.js
// module id = 17
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11